import React from 'react'


export default function SignUp(){
    return <h1 className="sign-up">Sign-up</h1>
}